import { useEffect, useState } from "react";
import Image from "next/image";
import { useInView } from "react-hook-inview";
import style from "../styles/components/MapGrave.module.scss";
import mapImage from "../public/img/about/map.png";
import MapChristmasStar from "./MapChristmasStar";

export default function MapPlacesChristmas({
  innerClassName = "",
  className = "",
}) {
  const [animated, setAnimated] = useState(false);

  const [refMapWrapper, isVisible] = useInView({
    threshold: 0.5,
  });

  useEffect(() => {
    if (isVisible && !animated) {
      setAnimated(true);
    }
  }, [isVisible, animated]);

  return (
    <div
      className={`${style.mapWrapper} ${animated ? style.animated : ""} ${className}`}
    >
      <div
        className={`relative overflow-hidden ${innerClassName}`}
        ref={refMapWrapper}
      >
        <Image src={mapImage} alt="" />
        <div className="overlay">
          <MapChristmasStar top="17.5%" left="61.5%" number={1} />
          <MapChristmasStar top="37%" left="73%" number={2} />
          <MapChristmasStar top="80%" left="26%" number={3} />
          <MapChristmasStar top="82%" left="75%" number={3} />
        </div>
      </div>
    </div>
  );
}
